<template>
  <div :class="$style.bracelet" />
</template>

<script>
import Bracelet from '@/scripts/Bracelet'
import EventBus from '@/scripts/event-bus'
import MouseUtil from '@/scripts/MouseUtil'
import loop from '@/scripts/loop';


export default {
  name: 'BigMenuBracelet',

  mounted() {
    this.meshInScene = false;
    this.Bracelet = new Bracelet(this.$el.parentNode);
    this.mouseUtil = new MouseUtil(this.$el.parentNode, 0.9);
    this.mouseUtil.init();

    const handlerRender = time => this.render(time);
    loop.add(() => handlerRender(), 'bracelet_render');
    this.Bracelet.loadMesh('/static/bracelet/bracelet.fbx').then(() => {
      this.Bracelet.setup();
      this.Bracelet.setupObj();
      this.meshInScene = true;

      EventBus.$on('windowResize', this.resize.bind(this));
    });
  },

  methods: {
    resize() {
      this.Bracelet.resize();
    },

    render(time) {
      if (!this.meshInScene) return;
      this.Bracelet.render(time);
      this.mouseUtil.getLerpedVal();

      this.Bracelet.rotationY = -20 + (100 * this.mouseUtil.positionLerpedNormX);
      this.Bracelet.rotationX = -60 + (15 * this.mouseUtil.positionLerpedNormY);
    },
  },
};
</script>

<style lang="scss" module>
.bracelet {
  &,
  & > canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BigMenuBracelet.vue